//www.paypal.com/donate?hosted_button_id=6X43CPNT5B9YW
import React, { Fragment, useState } from "react";
import { sendFeedback } from "../api/feedbackApi";
import "./Footer.css";
import Modal from "react-modal";

export default function Footer(props) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [afterFeedback, setAfterFeedback] = useState(false);

  function send(e) {
    e.preventDefault();
    sendFeedback({ email, message }).then((res) => {
      console.log("res");
      if (res.data && res.data.success) {
        setEmail("");
        setMessage("");
        setAfterFeedback(true);
      }
    });
  }

  function canSubmit() {
    if (email.trim() != "" && message.trim() != "") {
      return true;
    }

    return false;
  }
  return (
    <footer className="container pt-4 my-md-5 pt-md-5 border-top">
      <div className="row">
        <div className="col-6 col-md">
          <img
            class="mb-2"
            src="/squish-alert-frog.png"
            alt="squishalert-logo"
            height="40"
          />
          <small class="d-block mb-3 text-muted">© 2021</small>
        </div>
        <div class="col-6 col-md">
          <h5>About</h5>
          <ul class="list-unstyled text-small">
            <li class="mb-1">
              <a
                class="link-secondary text-decoration-none"
                href="https://www.squishalert.com/privacy-policy"
              >
                Privacy Policy
              </a>
            </li>
            <li class="mb-1">
              <a
                class="link-secondary text-decoration-none"
                href="https://www.squishalert.com/terms-of-use"
              >
                Terms of Use
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <div className="d-flex flex-row align-items-center text-secondary">
            <i class="far fa-envelope fa-lg"></i>
            <a
              className="link-secondary px-2"
              style={{ textDecoration: "none" }}
              href="mailto:hello@squishalert.com"
            >
              : hello@squishalert.com
            </a>
          </div>
          <div>
            <div className="d-flex flex-row align-items-center text-secondary">
              <i className="fab fa-instagram fa-lg  "></i>
              <a
                className="link-secondary px-2"
                style={{ textDecoration: "none" }}
                href="https://instagram.com/squishalert.app"
                target="_blank"
              >
                : @squishalert.app
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
  return (
    <Fragment>
      <footer id="footer" class="footer">
        <div class="main-footer widgets-dark">
          <div class="container">
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-3">
                <div class="widget no-box">
                  <h5 class="widget-title">
                    Support us<span></span>
                  </h5>
                  <a
                    className="btn btn-primary"
                    href="https://www.paypal.com/donate?hosted_button_id=6X43CPNT5B9YW"
                    target="_blank"
                  >
                    Support us <i class="fas fa-donate"></i>
                  </a>
                </div>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-3">
                <div class="widget no-box">
                  <h5 class="widget-title">
                    Contact Us<span></span>
                  </h5>
                  <p>
                    <a href="mailto:hello@shlime.co" title="glorythemes">
                      hello@shlime.co
                    </a>
                  </p>{" "}
                  <div> or</div>
                  <form>
                    <input
                      className="form-control"
                      type="email"
                      placeholder="Your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <textarea
                      className="form-control"
                      placeholder="Feedback or Issues"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    ></textarea>
                    <button
                      className="btn btn-primary"
                      onClick={send}
                      disabled={!canSubmit()}
                    >
                      Send
                    </button>
                  </form>
                  {/* <ul class="social-footer2">
                  <li class="">
                    <a
                      title="youtube"
                      target="_blank"
                      href="https://www.youtube.com/"
                    >
                      Icon
                    </a>
                  </li>
                </ul> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-copyright">
          <div class="container">
            <div class="row">
              <div class="col-md-12 text-center">
                <p>Copyright Shlime LLC © 2021. All rights reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <MessageSentModal
        isVisible={afterFeedback}
        setVisible={setAfterFeedback}
      />
    </Fragment>
  );
}

export function MessageSentModal(props) {
  const { isVisible, setVisible } = props;

  return (
    <Modal
      isOpen={isVisible}
      // onAfterOpen={afterOpenModal}
      onRequestClose={() => setVisible(false)}
      style={customStyles}
      contentLabel="Verification Code"
    >
      <button className="btn modal-close-btn" onClick={() => setVisible(false)}>
        <i className="fas fa-times"></i>
      </button>
      <h2 className="text-success text-center">
        <i class="fas fa-check-circle"></i>
      </h2>
      <h5>Thank you. Your message was sent. We will take a look at it.</h5>
    </Modal>
  );
}

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "500px",
  },
};
